<div class="item-card">
  <div class="top-section">
    <div class="timer-section" *ngIf="showTimer">
      <div class="d-flex justify-content-between mb-2">
        <div class="">
          <span class="item-name"> Item {{ currentIndex }} of {{ itemsLength }}</span>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="timer-pill">TIMER {{ formatTime(workDuration) }}</span>
          <button class="pause-btn custom-btn" (click)="toggleTimer()">
            <img src="assets/images/icons/pause-bun.svg" alt="" />
          </button>
        </div>
      </div>
      <div class="progress-container">
        <div class="progress-bar-wrapper">
          <progress class="progress-bar" [value]="progress" max="100"></progress>
          <span class="progress-percent">{{ progress }}%</span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="d-flex justify-content-between border-gray gap-3"
    style="padding: 18px 16px"
    *ngIf="Scope == transferScope.LicensePlate"
  >
    <div>
      <div class="item-name">{{ item.licensePlate?.referenceNumber }}</div>
      <div class="item-location" *ngIf="showLocatoin">
        Pick Location:{{ item.licensePlate?.warehouseLocation?.name }}
      </div>
    </div>
    <div class="ms-auto lg-header-text text-nowrap">
      Total Items: {{ getLicensePlateItemsQuantity(item.licensePlate) }}
    </div>
  </div>
  <div
    class="d-flex justify-content-start border-gray gap-3"
    style="padding: 18px 16px"
    *ngIf="Scope != transferScope.LicensePlate"
  >
    <div>
      <img
        class="item-image"
        [src]="
          product.productImages && product.productImages.length > 0 && product.productImages[0]?.url
            ? product.productImages[0]?.url
            : 'assets/images/icons/ic_demo_img.svg'
        "
        alt=""
      />
    </div>
    <div class="d-flex flex-column justify-content-center align-items-start">
      <div class="item-name">{{ getShortProductName(product.name ?? '') }}</div>
      <div class="item-location" *ngIf="showLocatoin">
        Pick Location:
        {{ product.warehouseLocations?.[0]?.name || '' }}
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between gap-2" *ngIf="Scope != transferScope.LicensePlate">
    <div class="required-quantity-box">
      <span class="label">{{ qtyLable }}</span>
      <span class="quantity-font" style="color: #0c9aeb"> {{ requiredQuantity }}</span>
    </div>
    <div class="picked-quantity-box">
      <span class="label">{{ readyLable }}</span>
      <span class="quantity-font" style="color: #12b769">{{ pickedQuantity }}</span>
    </div>
    <div class="remain-quantity-box">
      <span class="label">{{ remainLable }}</span>
      <span class="quantity-font" style="color: #f04438">{{ remainQuantity }}</span>
    </div>
  </div>
  <div class="package-card my-2" *ngIf="Scope != transferScope.LicensePlate">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0">SELECTED PACKAGE</h6>
      <div>
        <button
          class="link me-1"
          style="background: none; border: none"
          (click)="selectBox()"
          data-bs-toggle="offcanvas"
          data-bs-target="#switchBoxAction"
          aria-controls="switchBoxAction"
        >
          Switch
        </button>
        <span class="badge"
          >{{ selectedTransferDispatchBox.shipmentBox.name }}-{{
            selectedTransferDispatchBox.name
          }}</span
        >
      </div>
    </div>

    <!-- Weight -->
    <div class="d-flex justify-content-between small mb-1">
      <span>Weight</span>
      <span
        ><strong
          >{{ matrix.preview.weight.value | number: '1.2-2' }}

          kg /
          {{
            getWeightInKg(
              selectedTransferDispatchBox.shipmentBox.maxWeight,
              selectedTransferDispatchBox.shipmentBox.weightUnit
            ) | number: '1.2-2'
          }}
          kg</strong
        ></span
      >
    </div>
    <div class="progress mb-1">
      <div
        class=""
        [style.width]="matrix.preview.weight.percent + '%'"
        style="background: #0070b9"
      ></div>
    </div>
    <div class="small text-muted mb-3 te" style="text-align: start">
      Packed:{{ matrix.current.weight.value | number: '1.2-2' }} kg + Adding:
      {{ matrix.preview.weight.value - matrix.current.weight.value | number: '1.2-2' }} kg
    </div>

    <!-- Volume -->
    <div class="d-flex justify-content-between small mb-1">
      <span>Volume</span>
      <span
        ><strong>{{ matrix.preview.volume.percent | number: '1.2-2' }}% used</strong></span
      >
    </div>
    <div class="progress">
      <div
        class=""
        [style.width]="matrix.preview.volume.percent + '%'"
        style="background: #0070b9"
      ></div>
    </div>
  </div>
</div>
